import { render, staticRenderFns } from "./claimInfoOld.vue?vue&type=template&id=7963c259&scoped=true"
import script from "./claimInfoOld.vue?vue&type=script&lang=js"
export * from "./claimInfoOld.vue?vue&type=script&lang=js"
import style0 from "./claimInfoOld.vue?vue&type=style&index=0&id=7963c259&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963c259",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7963c259')) {
      api.createRecord('7963c259', component.options)
    } else {
      api.reload('7963c259', component.options)
    }
    module.hot.accept("./claimInfoOld.vue?vue&type=template&id=7963c259&scoped=true", function () {
      api.rerender('7963c259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordManage/claimInfoOld.vue"
export default component.exports